import styled from 'styled-components'

export const PageStyled = styled.div`
  display: flex;
  padding-top: 10%;
  flex-direction: column;
  align-items: center;
`
